import {AUTH_TOKENS_STORAGE, C_OTC_STORAGE, PASSWORD} from "../environment";


export const getUserDataFromLocalStorage = () => {
  const userObj =
    (localStorage.getItem(C_OTC_STORAGE) &&
      JSON.parse(localStorage.getItem(C_OTC_STORAGE))) ||
    null;
  return userObj;
};
export const setUserDataInLocalStorage = (user) => {
  localStorage.setItem(C_OTC_STORAGE, JSON.stringify(user));
}

export const setAuthTokens = (tokens) => {
  localStorage.setItem(AUTH_TOKENS_STORAGE, JSON.stringify(tokens));
};
export const getAuthTokens = () => {
  const raw = localStorage.getItem(AUTH_TOKENS_STORAGE);
  return (raw && JSON.parse(raw)) || null;
};
export const clearAuthTokens = () => {
  localStorage.removeItem(AUTH_TOKENS_STORAGE);
};

// Every existing dashboard/product/service page reads a flat `ssoId`-keyed
// user object from localStorage (a holdover from the old phone-number-as-id
// login). auth-service returns a real { id, email, phone, profile, ... }
// user — this bridges the new shape into the old one so none of those
// pre-existing call sites need to change in this pass.
export const buildLegacyUserFromAuthUser = (user) => ({
  ssoId: user.phone || user.email,
  id: user.id,
  email: user.email,
  mobileNumber: user.phone || "",
  firstName: user.profile?.firstName || "",
  lastName: user.profile?.lastName || "",
  provider: user.organization?.name || "",
  role: user.role,
});

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const validatePassword = (password) => {
  if (
    (password !== undefined) && (password.trim() === "" || password.length < PASSWORD.passwordLength)
    // || !values.password.match('[a-z]')
    // || !values.password.match('[A-Z]')
    // || !values.password.match('[0-9]')
    // || !values.password.match(/[\*\.\!\@\#\$\%\^\&\(\)\{\}\[\]\:\;\<\>\,\.\?\/\~\_\+\-\=\|\\]/)
  ) {
    return (PASSWORD.passwordLengthError)
  }
  return null;

}
export const onChangeInput = (value, key, prevState, setState) => {
  // if(key ==  "Mobile Number")
  // key="mobileNumber"
  // else if(key == "Confirm Password")
  // key = "confirmPassword"
  // else if(key == "Company Name")
  // key = "provider"
  // else if(key == "first Name")
  // key = "firstName"
  // else if(key == "last Name")
  // key = "lastName"

  setState((prevState) => ({
    ...prevState,
    values: {
      ...prevState.values,
      [key]: value,
    },
    errors: {
      ...prevState.errors,
      [key]: "",
    }
  }));
};

export const validateInputs = (values) => {
  let keys = Object.keys(values);
  const len = keys.length;
  let recordedErrors = {};
  let value = ''
  for (let i = 0; i < len; i++) {
    value = values[keys[i]]
    if (value !== undefined && value.toString().trim().length <= 0) {
      recordedErrors = {...recordedErrors, [keys[i]]: `${keys[i]} is required`}
    }
  }
  return (recordedErrors);
}


export const getDateFromDateTime = (date) => new Date(date).toLocaleString().split(',')[0]

export const multiFileHandler = (oldValues = [], currentValue = []) => {
  let oldLength = oldValues.length;
  let updated = [...oldValues]
  let found = false;
  let j = 0;
  for (let i = 0; i < currentValue.length; i++) {
    j = 0;
    found = false;
    for (; j < oldLength; j++) {
      if (oldValues[j].name === currentValue[i].name) {
        found = true;
        break;
      }
    }
    if (!found) {
      updated.push(currentValue[i])
    }
  }
  if (oldLength === 0) {
    updated = [...currentValue]
  }
  return (updated)
}



export const lengthValidator = (value = '', minLength = '', maxLength = '') => {
  let dataLength = value.length;

  if (minLength && maxLength)
    return (dataLength >= minLength && dataLength <= maxLength)
  else
    return (dataLength >= minLength )

}

